export default "__VITE_ASSET__BCDXlobO__"